import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import HundpensionatPage from "@/pages/HundpensionatPage";
import HunddagisPage from "@/pages/HunddagisPage";
import HundrastningPage from "@/pages/HundrastningPage";
import PricingPage from "@/pages/PricingPage";
import AboutPage from "@/pages/AboutPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import CookiesPage from "@/pages/CookiesPage";
import LocalCityPage from "@/pages/LocalCityPage";
import CaseStudyPage from "@/pages/CaseStudyPage";
import { LeadCaptureProvider } from "@/context/LeadCaptureContext";
import { CookieConsentProvider } from "@/context/CookieConsentContext";
import AnalyticsLoader from "@/components/AnalyticsLoader";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false} storageKey="hundify-theme">
        <BrowserRouter>
          <LeadCaptureProvider>
            <CookieConsentProvider>
              <AnalyticsLoader />
              <div className="App">
                <Routes>
                  <Route path="/" element={<Landing />} />
                  <Route path="/hundpensionat-system" element={<HundpensionatPage />} />
                  <Route path="/hunddagis-app" element={<HunddagisPage />} />
                  <Route path="/hundrastning-program" element={<HundrastningPage />} />
                  <Route path="/pricing" element={<PricingPage />} />
                  <Route path="/om-oss" element={<AboutPage />} />
                  <Route path="/integritetspolicy" element={<PrivacyPage />} />
                  <Route path="/villkor" element={<TermsPage />} />
                  <Route path="/cookies" element={<CookiesPage />} />
                  <Route path="/lokalt/:city" element={<LocalCityPage />} />
                  <Route path="/kunder/:slug" element={<CaseStudyPage />} />
                </Routes>
                <Toaster position="top-right" />
              </div>
            </CookieConsentProvider>
          </LeadCaptureProvider>
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
